import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MovementManagerDescriptionDialogComponent } from './movement-manager-description-dialog.component';

/**
 * Modulo dedicato alla modale di visualizzazione descrizione completa articolo
 */
@NgModule({
  declarations: [
    MovementManagerDescriptionDialogComponent
  ],
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    MatLegacyButtonModule,
    MatIconModule,
    FlexLayoutModule,
    TranslateModule
  ],
  exports: [
    MovementManagerDescriptionDialogComponent
  ]
})
export class MovementManagerDescriptionDialogModule { }
